import { colors } from "@/styles/colors";
import { FunctionComponent, ReactElement } from "react";
import { Bars } from "react-loader-spinner";
import styles from "./Loader.module.scss";
import { ILoaderProps } from "./types";

export const Loader: FunctionComponent<ILoaderProps> = (
  props: ILoaderProps
): ReactElement<ILoaderProps> => {
  const { children, ...restProps } = props;

  return (
    <div className={styles.containerDefault} {...restProps}>
      {children || (
        <Bars
          ariaLabel="bars-loading"
          color={colors.palette.black}
          height={30}
          visible
          width={30}
        />
      )}
    </div>
  );
};
